const Checkbox = {
  parts: ["control"],
  baseStyle: { control: { borderColor: "gray.500" } },
};

export default Checkbox;
